var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      class: {
        categoryNaviItem: true,
        arrow: _vm.showArrow,
        icon: _vm.showIcon,
        rsp2Hatching: _vm.hatching
      }
    },
    [
      _c("a", { attrs: { href: _vm.finalUrl } }, [
        _vm.icon && _vm.showIcon
          ? _c("div", { staticClass: "iconContainer" }, [
              _c("div", {
                staticClass: "icon",
                domProps: { innerHTML: _vm._s(_vm.icon) }
              })
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _vm.tags && Object.keys(_vm.tags).length > 0
            ? _c(
                "div",
                { staticClass: "tags" },
                _vm._l(_vm.tags, function(color, name) {
                  return _c(
                    "span",
                    { key: name, style: { backgroundColor: color } },
                    [_vm._v(_vm._s(name))]
                  )
                })
              )
            : _vm._e(),
          _vm._v(" "),
          _c("h3", {
            class: {
              title: true,
              small: _vm.size === "s",
              large: _vm.size === "l"
            },
            domProps: { innerHTML: _vm._f("hyphen")(_vm.title) }
          }),
          _vm._v(" "),
          _vm.description && _vm.showDescription
            ? _c("p", { staticClass: "description" }, [
                _vm._v(_vm._s(_vm.description))
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _vm.showArrow
          ? _c("div", { staticClass: "arrow" }, [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "13",
                    height: "22",
                    viewBox: "0 0 47.155 83.419"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      d:
                        "M42.556,50.351,14.075,19.343a6.3,6.3,0,0,1,0-8.868,6.17,6.17,0,0,1,8.783,0L57.584,45.909a6.31,6.31,0,0,1,0,8.874L22.859,90.216a6.155,6.155,0,0,1-8.783,0,6.3,6.3,0,0,1,0-8.868Z",
                      transform: "translate(-12.252 -8.639)"
                    }
                  })
                ]
              )
            ])
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }